<template>
    <div>
        <div class="app-block p-md m-md">
            <form @submit.prevent="send">
                <h3 class="heading-line title is-4 has-text-weight-light"><span
                    :style="'color: '+school">Cursus Académique</span>
                </h3>
                <div>

                    <div class="columns">
                        <div class="column">
                            <h4 class="title is-5 has-text-weight-light">Classe actuelle</h4>
                            <b-select v-model="cursus.current_grade"
                                      name="series">
                                <option disabled value="">...</option>
                                <option
                                        v-for="grade in grades"
                                        :value="grade"
                                        :key="grade">
                                    {{ grade }}
                                </option>
                            </b-select>

                        </div>
                    </div>
                    <div class="columns">
                        <div class="column is-5">
                            <h4 v-bind:class="[ errors.has('baccalaureate') ? 'has-text-danger' : '']">Bac obtenu</h4>
                            <div class="radio-group">
                                <label>
                                    <input type="radio" name="baccalaureate" v-validate="'required|in:current,yes,no'"
                                           :value="'current'"
                                           v-model="cursus.baccalaureate">
                                    <div class="choice">
                                        <span>En cours</span>
                                    </div>
                                </label>
                                <label>
                                    <input type="radio" name="baccalaureate" :value="'yes'"
                                           v-model="cursus.baccalaureate">
                                    <div class="choice">
                                        <span>Oui</span>
                                    </div>
                                </label>
                                <label>
                                    <input type="radio" name="baccalaureate" :value="'no'"
                                           v-model="cursus.baccalaureate">
                                    <div class="choice">
                                        <span>Non</span>
                                    </div>
                                </label>
                            </div>

                        </div>
                        <div class="column is-3">
                            <transition name="slide-fade">
                                <div v-if="cursus.baccalaureate === 'yes' || cursus.baccalaureate === 'current'">
                                    <h4 v-bind:class="[ errors.has('series') ? 'has-text-danger' : '']">
                                        Série</h4>
                                    <b-select  v-model="cursus.baccalaureate_series"
                                               v-validate="'required'" name="series">
                                        <option disabled value="">Choix de la série</option>
                                        <option
                                                v-for="bac in baccalaureates"
                                                :value="bac"
                                                :key="bac">
                                            {{ bac }}
                                        </option>
                                    </b-select>
                                    <transition name="slide-fade">
                                        <div>
                                            <input class="input" type="text" v-model="cursus.baccalaureate_other"
                                                   v-if="cursus.baccalaureate_series === 'Autre'">
                                        </div>
                                    </transition>
                                </div>
                            </transition>
                        </div>
                        <div class="column is-3">
                            <transition name="slide-fade">
                                <div v-if="cursus.baccalaureate === 'yes'">
                                    <h4 v-bind:class="[ errors.has('year') ? 'has-text-danger' : '']">
                                        Année</h4>
                                    <b-select  v-model="cursus.baccalaureate_year"
                                               v-validate="'required'" name="year">
                                        <option disabled value="">Année</option>
                                        <option
                                                v-for="year in years"
                                                :value="year"
                                                :key="year">
                                            {{ year }}
                                        </option>
                                    </b-select>
                                </div>
                            </transition>
                        </div>

                    </div>

                    <hr>
                    <div>
                        <h4 class="title is-5 has-text-weight-light">Diplômes supérieurs ou professionnels obtenus</h4>


                        <transition-group name="slide-fade">
                            <div v-for="(degree, index) in degrees" :key="index+1" class="columns">
                                <div class="column is-6">
                                    <input class="input" type="text" v-model="degree.name" placeholder="Diplôme">
                                </div>
                                <div class="column is-3">
                                    <b-select  name="degree-year"
                                               v-validate="`${degree.name.length > 0 ? 'required' : ''}`"
                                               data-vv-as="L'année d'obtention"
                                               v-model="degree.year">


                                        <option disabled value="">Année</option>
                                        <option
                                                v-for="year in years"
                                                :value="year"
                                                :key="year">
                                            {{ year }}
                                        </option>
                                    </b-select>
                                    <span v-show="errors.has('degree-year')" class="help is-danger">{{ errors.first('degree-year') }}</span>
                                </div>
                                <div class="column is-1">
                                    <a class="button" v-on:click="removeDegree(index);" style="cursor: pointer"><i
                                            class="fa fa-trash-o" aria-hidden="true"></i>
                                    </a>
                                </div>
                                <hr>

                            </div>
                        </transition-group>

                        <br>
                        <div class="has-text-centered">
                            <a v-if="degrees.length <= 10" class="button"
                               @click="addDegree">
                                <span>Ajouter un diplôme</span>
                            </a>
                        </div>

                    </div>
                    <h4 class="title is-5 has-text-weight-light">Langues étrangères</h4>
                    <div class="columns">
                        <div class="column">
                            <h5><label class="label">Lv1</label></h5>
                            <b-select  v-model="cursus.lv1" name="Lv1">
                                <option value=""></option>
                                <option
                                        v-for="lv in langages"
                                        :value="lv"
                                        :key="lv"
                                        :disabled="lv === cursus.lv2 || lv === cursus.lv3">
                                    {{ lv }}
                                </option>
                            </b-select>
                        </div>
                        <div class="column">
                            <h5><label class="label">Lv2</label></h5>
                            <b-select  v-model="cursus.lv2" name="Lv2">
                                <option value=""></option>
                                <option
                                        v-for="lv in langages"
                                        :value="lv"
                                        :key="lv"
                                        :disabled="lv === cursus.lv1 || lv === cursus.lv3">
                                    {{ lv }}
                                </option>
                            </b-select>
                        </div>
                        <div class="column">
                            <h5><label class="label">Lv3</label></h5>
                            <b-select  v-model="cursus.lv3" name="Lv3">
                                <option value=""></option>
                                <option
                                        v-for="lv in langages"
                                        :value="lv"
                                        :key="lv"
                                        :disabled="lv === cursus.lv1 || lv === cursus.lv2">
                                    {{ lv }}
                                </option>
                            </b-select>
                        </div>
                    </div>
                </div>
                <br>
                <div class="has-text-right">
                    <transition name="slide-fade">
                        <div class="has-text-danger has-text-centered">{{ errorMsg }}</div>
                    </transition>

                    <button :class="'button-valid button ' + isLoading" v-if="user.isLoggedIn">
                        Sauvegarder
                    </button>
                    <button class="button" v-else disabled>
                        Sauvegarder
                    </button>
                </div>
            </form>
        </div>
    </div>

</template>

<script>
    import {mapActions, mapGetters, mapState} from 'vuex'
    import _ from 'lodash'

    export default {
        data () {
            return {
                isLoading: '',
                errorMsg: '',
                cursus: {
                    baccalaureate: '',
                    baccalaureate_series: '',
                    baccalaureate_other: '',
                    baccalaureate_year: '',
                    degrees: '',
                    lv1: '',
                    lv2: '',
                    lv3: '',
                    cursusYear1: '',
                    cursusDegree1: '',
                    cursusYear2: '',
                    cursusDegree2: '',
                    cursusYear3: '',
                    cursusDegree3: ''
                },
                degrees: [
                    {
                        id: '',
                        year: '',
                        name: ''
                    }
                ],
                years: [],
                grades: [
                    'Aucune',
                    '4eme',
                    '3eme',
                    'Seconde',
                    'Première',
                    'Terminale',
                    'Bac+1',
                    'Bac+2',
                    'Bac+3',
                    'Bac+4',
                    'Bac+5'
                ],
                baccalaureates: [
                    'S',
                    'L',
                    'ES',
                    'ST2S',
                    'STL',
                    'STAV',
                    'STMG',
                    'Bac pro',
                    'Bac étranger',
                    'DAEU',
                    'Autre'
                ],
                langages: [
                    'Anglais', 'Espagnol', 'Italien', 'Allemand', 'Chinois', 'Japonais', 'Russe', 'Portugais', 'Arabe classique', 'autre'
                ]
            }
        },
        props: {
            school: {type: String},
            candidate: { type: Object }
        },
        computed: {
            ...mapGetters({
                application: 'candidate/getSingleApplication',
                status: 'candidate/getStatus'
            }),
            ...mapState({
                user: 'auth'
            })
        },
        methods: {

            ...mapActions({
                sendCurriculum: 'candidate/saveCurriculum'
            }),
            toggleLoading: function () {
                this.isLoading = (this.isLoading === '') ? 'is-loading' : ''
            },
            send: function () {
                this.$validator.validateAll().then((valid) => {
                    this.toggleLoading()
                    if (valid) {
                        this.cursus.candidate_id = this.candidate.id
                        this.cursus.degrees = this.degrees
                        this.sendCurriculum(this.cursus).then((result) => {
                            if (this.status === 200) {
                                this.toggleLoading()
                                this.$emit('send')
                            } else {
                                this.toggleLoading()
                                this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
                            }
                        }).catch(() => {
                            this.toggleLoading()
                            this.errorMsg = 'Une erreur s\'est produite veuillez réessayer plus tard'
                        })
                    } else {
                        this.toggleLoading()
                        this.errorMsg = 'Veuillez renseigner les champs requis'
                    }
                })
            },
            setYears: function () {
                let currentYear = new Date().getFullYear()
                const startYear = 1960
                const years = []

                while (startYear <= currentYear) {
                    years.push(currentYear--)
                }

                return years
            },
            addDegree: function () {
                this.degrees.push({
                    id: '',
                    year: '',
                    name: ''
                })
            },
            removeDegree: function (index) {
                this.degrees.splice(index, 1)
            }
        },
        created () {
            this.years = this.setYears()
            if (!_.isEmpty(this.candidate.curriculum)) {
                this.cursus = this.candidate.curriculum
                if (!_.isEmpty(this.candidate.curriculum.degrees)) {
                    this.degrees = this.candidate.curriculum.degrees
                }
            }
        }
    }
</script>
